export default {
      id: "i-service-about-usage",
      viewBox: "0 0 156 136",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-about",
      toString: function () {
        return this.url;
      }
    }